var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"length":_vm.lastPage,"total-visible":5,"color":"primary"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }